/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import { commonConstants, decrypt, encrypt } from '../constants';
import { accountService } from '../services';
import { setPayload } from '../helpers/storageUtils';

export const accountActions = {
  register,
  verifyOtp,
  login,
  confirmSignIn,
  getSession,
  forgotPassword,
  resetPassword,
  logout,
  completeNewPassword,
  updateCognitoUser,
  setLoginUser,
  sendSMSOTP,
  verifySMSOTP,
};

function getSession(callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .getSession()
      .then((response) => {
        dispatch(hideLoader());
        let payload = response.tokens.idToken.payload;
        let userInfo = localStorage.getItem('userInfo');
        if (userInfo && userInfo !== null) payload['custom:userInfo'] = userInfo;
        setPayload(JSON.stringify(payload));
        dispatch(setLoginUser(payload));
        callback(null, response);
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error, null);
      });
  };
}

function setLoginUser(user) {
  return { type: commonConstants.SET_LOGIN_USER, user };
}

function logout(callback) {
  showLoader();
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .logout()
      .then(() => {
        dispatch(resetCpaDetails({}));
        dispatch(hideLoader());
        callback(null);
      })
      .catch(function () {
        dispatch(hideLoader());
      });
  };
}

function resetCpaDetails(cpaDetails) {
  return {
    type: commonConstants.RESET_PLAN_LOGO,
    cpaDetails,
  };
}

function resetPassword(username, otp, password, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .resetPassword(username, otp, password)
      .then((response) => {
        dispatch(hideLoader());
        callback(null, response);
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error);
      });
  };
}

function forgotPassword(username, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .forgotPassword(username)
      .then((response) => {
        dispatch(hideLoader());
        if (response) {
          callback(null, response);
        }
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error);
      });
  };
}

function register(user, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .register(user)
      .then((response) => {
        dispatch(hideLoader());
        if (response) {
          callback(null, response);
        }
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error);
      });
  };
}

function verifyOtp(username, otp, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .verifyOtp(username, otp)
      .then((response) => {
        dispatch(hideLoader());
        if (response) {
          callback(null, response);
        }
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error, null);
      });
  };
}

function completeNewPassword(user, newPassword, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .completeNewPassword(user, newPassword)
      .then((response) => {
        dispatch(hideLoader());
        if (response) {
          callback(null, response);
        }
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error, null);
      });
  };
}

function confirmSignIn(user, code, mfaType, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .confirmSignIn(user, code, mfaType)
      .then((response) => {
        dispatch(hideLoader());
        if (response) {
          callback(null, response);
        }
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error, null);
      });
  };
}

function login(credentials, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .login(credentials)
      .then((response) => {
        dispatch(hideLoader());
        if (!response.error) {
          callback(null, response);
        } else {
          dispatch(hideLoader());
          callback({ message: response.error }, null);
        }
      })
      .catch(function (error) {
        dispatch(hideLoader());
        callback(error, null);
      });
  };
}

function updateCognitoUser(data, callback) {
  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .updateCognitoUser(data)
      .then((res) => {
        if (res.success) {
          dispatch(hideLoader());
          callback(null, res);
        } else {
          dispatch(hideLoader());
          callback(res.err, null);
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
        callback(err, null);
      });
  };
}

function sendSMSOTP(data, callback) {
  // REMOVED: data = encrypt(data);
  // Encryption will be handled by apiUtils.js to avoid double encryption

  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .sendSMSOTP(data)
      .then((res) => {
        res = JSON.parse(decrypt(res.r));
        dispatch(hideLoader());
        callback(null, res);
      })
      .catch((err) => {
        dispatch(hideLoader());
        callback(err, null);
      });
  };
}

function verifySMSOTP(data, callback) {
  // REMOVED: data = encrypt(data);
  // Encryption will be handled by apiUtils.js to avoid double encryption

  return (dispatch) => {
    dispatch(showLoader());
    accountService
      .verifySMSOTP(data)
      .then((res) => {
        res = JSON.parse(decrypt(res.r));
        if (res.success) {
          dispatch(hideLoader());
          callback(null, res);
        } else {
          dispatch(hideLoader());
          callback(res, null);
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
        callback(err, null);
      });
  };
}

function showLoader() {
  return { type: commonConstants.SHOW_LOADER };
}

function hideLoader() {
  return { type: commonConstants.HIDE_LOADER };
}
